export default function WhatsAppButton() {
  const numbers = [
    "5215511733326", // Número 1
    "5217771143440", // Número 2
    "5215542896541"  // Número 3
  ];

  const defaultMessage = "Hola, me interesa más información de eventos, artistas.";

  const openWhatsApp = () => {
    // Selecciona un número aleatorio de la lista
    const randomIndex = Math.floor(Math.random() * numbers.length);
    const selectedNumber = numbers[randomIndex];

    // Construye la URL de WhatsApp
    const url = `https://wa.me/${selectedNumber}?text=${encodeURIComponent(defaultMessage)}`;

    // Abre WhatsApp en una nueva pestaña
    window.open(url, "_blank");
  };

  return (
    <button
      onClick={openWhatsApp}
      className="fixed bottom-6 right-6 w-16 h-16 bg-gradient-to-r from-teal-600 to-teal-500 text-white rounded-full shadow-2xl hover:from-teal-700 hover:to-teal-600 transition-all duration-300 z-50 flex items-center justify-center group hover:scale-110 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl w-8 h-8 flex items-center justify-center"></i>
      
      {/* Efecto de pulso */}
      <span className="absolute inset-0 rounded-full bg-teal-500 opacity-75 animate-ping"></span>
    </button>
  );
}
